import React, { Component } from 'react'
import { bookmakers } from 'config'
import { Panel } from 'react-bootstrap'
import { editList, deleteList } from 'actions/bookmakerLists'

export default class BookmakerListComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editing: false,
      name: this.props.name,
      bookmakers: this.props.bookmakers
    }
    this.toggleBookmaker = this.toggleBookmaker.bind(this)
    this.deleteList = this.deleteList.bind(this)
  }

  toggleEdit(e) {
    e.preventDefault()
    if (this.state.editing) {
      // Is done editing
      const { listId, dispatch } = this.props
      dispatch(editList(listId, {
        name: this.state.name,
        bookmakers: this.state.bookmakers
      }))
    }
    this.setState({
      editing: !this.state.editing
    })
  }

  onChangeName(e) {
    this.setState({
      name: e.target.value
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      bookmakers: nextProps.bookmakers,
      name: nextProps.name
    })
  }

  deleteList() {
    const { listId, dispatch } = this.props
    dispatch(deleteList(listId))
  }

  toggleBookmaker(bookmaker) {
    if (!!this.state.bookmakers[bookmaker]) {
      delete this.state.bookmakers[bookmaker]
    } else {
      this.state.bookmakers[bookmaker] = true
    }
    this.setState({
      bookmakers: this.state.bookmakers
    })
  }



  render() {
    let content
    let name = this.state.name.toUpperCase()
    if (this.state.editing) {
      name = <input type='text' className='form-control' width='50%' value={this.state.name} onChange={this.onChangeName.bind(this)} />
      content = Object.keys(bookmakers).sort((a, b) => bookmakers[a].localeCompare(bookmakers[b])).map(bookmaker => {
        let className = 'bookmaker'
        if (this.state.bookmakers[bookmaker] === true)
          className += ' selected'
        return (
          <div key={bookmaker} className={className} onClick={this.toggleBookmaker.bind(this, bookmaker)}>{ bookmakers[bookmaker] }</div>
        )
      })
    } else {
      content = Object.keys(this.state.bookmakers).sort((a, b) => bookmakers[a].localeCompare(bookmakers[b])).map(bookmaker => {
        return <div key={bookmaker} className='bookmaker selected'>{ bookmakers[bookmaker] }</div>
      })
    }
    let header = (
      <div className='row'>
        <span>{ name }</span>
        <button className='btn btn-sm btn-danger pull-right' onClick={this.deleteList} >Delete</button>
        <button className='btn btn-sm btn-primary pull-right' onClick={this.toggleEdit.bind(this)}>
          { this.state.editing ? 'Done' : 'Edit list' }
        </button>
      </div>
    )
    return (
      <Panel className='bookmakerlist-panel' header={header}>
        { content }
      </Panel>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/profile/BookmakerListComponent.js
 **/